import React from "react";

/**
 * Mid-page Investor Access conversion hook for v2.
 * Sits between Partnership and Institutional Trust. Restrained, not loud.
 * The Apollo / KKR pattern: one assertive sentence + single CTA.
 */
const MidPageCTA = ({ onRequestAccess }) => {
  return (
    <section
      id="mid-cta"
      data-testid="kr-v2-mid-cta"
      className="relative py-28 lg:py-36 border-t border-[var(--kr-line-soft)] overflow-hidden"
      style={{ background: "var(--kr-bg-2)" }}
    >
      {/* faint gold scribble */}
      <div
        aria-hidden
        className="absolute -top-32 -left-32 w-[640px] h-[640px] rounded-full opacity-[0.10] blur-[120px]"
        style={{
          background:
            "radial-gradient(circle, rgba(201,169,110,0.65), transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -right-32 w-[520px] h-[520px] rounded-full opacity-[0.08] blur-[140px]"
        style={{
          background:
            "radial-gradient(circle, rgba(201,169,110,0.55), transparent 70%)",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-4 mb-8">
              <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
                05
              </span>
              <span className="w-12 h-px bg-[var(--kr-gold)]/60" />
              <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)]">
                Selective Engagement
              </span>
            </div>
            <h2 className="font-serif-display text-[var(--kr-text)] text-[clamp(2rem,4.6vw,3.6rem)] leading-[1.1] max-w-[22ch]">
              The partnership engages with{" "}
              <span className="italic text-[var(--kr-gold)]">
                sophisticated capital
              </span>{" "}
              — by introduction.
            </h2>
            <p className="mt-8 text-[var(--kr-text-muted)] text-[17px] leading-[1.8] max-w-[58ch]">
              Detailed materials are reserved for eligible, sophisticated,
              professional or institutional investors and shared only following
              appropriate review.
            </p>
          </div>

          <div className="lg:col-span-4 lg:text-right">
            <button
              type="button"
              onClick={onRequestAccess}
              data-testid="kr-v2-mid-cta-request"
              className="kr-btn-primary"
            >
              Request Investor Access
              <span aria-hidden>→</span>
            </button>
            <div className="mt-6 font-mono-label text-[10px] text-[var(--kr-text-dim)]">
              Confidential · By introduction
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
